import * as React from 'react'
import { PageSection, Title } from '@patternfly/react-core'
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb'
import GenericCard from '../../components/GenericCard'
import GenericButton from '../../components/GenericButton'
import { FormCancellaSTP } from './formIscrizioneSTP/FormCancellaSTP'
import {
    PATH_TO_BO_ANAG_ELENCO_ISCRITTI,
    PATH_TO_BO_ANAG_ELENCO_ISCRITTI_CANCELLA_ISCRITTO_STP
} from 'src/app/utils/RoutesConstants'
import GenericAlert from 'src/frontend/app/components/GenericAlert'
import { convertUrlParamsToObject } from 'src/utilities/utility'

class CancellaSTP extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            typeMessage: "default"
        };
    }

    goToElencoIscritti = (redirectLink: any) => {
        this.props.history.push({
            pathname: redirectLink,
        });
    }

    componentDidMount() {
        //recupero gli eventuali parametri dall'url
        var url = window.location.search?.split("?")[1]
        var urlParams = convertUrlParamsToObject(url)

        //recupero l'idIscrizione dall'url
        var idIscrizione = urlParams?.idIscrizione

        this.setState({ idIscrizione: idIscrizione })
    }

    submitMessageResult = (alert: any) => {
        const element = document.getElementById("pageSectionId");
        if (element)
            element.scrollIntoView({ behavior: 'smooth' });
        this.setState({ message: alert.messaggio, typeMessage: alert.type })
        if (alert.type === 'success') {
            setTimeout(async () => {
                this.goToElencoIscritti(PATH_TO_BO_ANAG_ELENCO_ISCRITTI)
            }, 1000);
        }
    }

    render() {
        const { message, typeMessage, idIscrizione } = this.state
        return (
            <>
                <PageSection id='pageSectionId'>
                    <div className='container register-container'>
                        <GenericBreadCrumb paths={[{ label: "Anagrafica", link: "#" }, { label: "Elenco iscritti", link: PATH_TO_BO_ANAG_ELENCO_ISCRITTI }, { label: "Cancellazione STP", link: PATH_TO_BO_ANAG_ELENCO_ISCRITTI_CANCELLA_ISCRITTO_STP }]} /><br></br>
                        <Title headingLevel="h1" size="4xl">Cancellazione STP</Title><br></br>
                        <GenericAlert hidden={message === ''} label={message} color={typeMessage}></GenericAlert>
                        <GenericCard isExpandibleCard={false} header={'Compila i seguenti campi'} body={<><FormCancellaSTP messaggio={this.submitMessageResult} idIscrizione={idIscrizione} /></>} /><br></br>
                        <div className='row'>
                            <div className='col-1'>
                                <GenericButton label={"INDIETRO"} color={"tertiary"} onClick={() => this.goToElencoIscritti(PATH_TO_BO_ANAG_ELENCO_ISCRITTI)} />
                            </div>
                            <div className='col-1'>
                                <GenericButton label={"CONFERMA"} type={"submit"} form={"idCancellaSTP"} color={"primary"} isDisabled={this.state.typeMessage === 'success'} />
                            </div>
                        </div>
                    </div>
                </PageSection>
                <br></br>
                <PageSection>
                    <div className='container register-container'>
                        <Title headingLevel='h3'>Legenda</Title>
                        <p>* Campo obbligatorio</p>
                    </div>
                </PageSection>
            </>
        )
    }
}

export default CancellaSTP;
